import {getLogger, CoreLoggerConfigurator} from "@goodgamestudios/logger";
export class LogMeister {
    public static addLogger(connector: ILogMeisterConnector): void {
        CoreLoggerConfigurator.useDefaults();
        getLogger("LogMeister").debug("empty implementation just to satisfy current api - behaviour is redirected to LoggingModule");
    }
    public static clearLoggers():void {
        getLogger("LogMeister").debug("empty implementation just to satisfy current api - behaviour is redirected to LoggingModule");
    }
}
export interface ILogMeisterConnector {
    format: string;
}

export class MonsterDebuggerConnector implements ILogMeisterConnector{
    constructor(value: any) {
    }
    public get format(): string {
        getLogger("ConsoleConnector").debug("empty implementation just to satisfy current api - behaviour is redirected to LoggingModule");
        return ""
    };

    public set format(value: string) {
        getLogger("ConsoleConnector").debug("empty implementation just to satisfy current api - behaviour is redirected to LoggingModule");
    }
}
export class ConsoleConnector implements ILogMeisterConnector {
    constructor(value?: any) {
    }

    public get format(): string {
        getLogger("ConsoleConnector").debug("empty implementation just to satisfy current api - behaviour is redirected to LoggingModule");
        return ""
    };

    public set format(value: string) {
        getLogger("ConsoleConnector").debug("empty implementation just to satisfy current api - behaviour is redirected to LoggingModule");
    }

}
export class LoggingConstants {
    // TODO @HTML5 this seems to be used once in BF only...   and string literals work differently anyway (
    public static FORMAT_DEFAULT_UNIT: string = "{message}";
    public static FORMAT_DEFAULT_SOS: string = "{sender.full}: {message}";
    public static FORMAT_DEFAULT_TRACE: string = "{level} | {sender.full}: {message}";
    public static FORMAT_DEFAULT_SOS_TIME: string = "{time.ms} [{sender}] {message}";
    public static FORMAT_DEFAULT_TRACE_TIME: string = "{time.ms} {level}\t[{sender.full}] {message}";
}
